import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scheduler-popup"
// data-scheduler-popup-target="popup" を吹き出し要素に付与する
export default class extends Controller {
  static targets = ["popup"];

  connect() {
    this.lastTapAt = 0;
    this.doubleTapThresholdMs = 2000;

    this.closeOnOutsideTap = this.closeOnOutsideTap.bind(this);
    this.openOnDoubleTap = this.openOnDoubleTap.bind(this);

    document.addEventListener("click", this.closeOnOutsideTap);
    document.addEventListener("touchend", this.closeOnOutsideTap);
    document.addEventListener("dblclick", this.openOnDoubleTap);
    document.addEventListener("touchend", this.openOnDoubleTap);
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideTap);
    document.removeEventListener("touchend", this.closeOnOutsideTap);
    document.removeEventListener("dblclick", this.openOnDoubleTap);
    document.removeEventListener("touchend", this.openOnDoubleTap);
  }

  closeOnOutsideTap(event) {
    if (this.popupTarget.style.display !== "block") return;
    if (this.popupTarget.contains(event.target)) return;

    this.popupTarget.style.display = "none";
  }

  async openOnDoubleTap(event) {
    const eventLine = event.target.closest(".dhx_cal_event_line");
    if (!eventLine) return;

    if (this.popupTarget.style.display === "block") {
      this.popupTarget.style.display = "none";
      return;
    }

    const workIdElement = eventLine.querySelector("[name=large_work_id]");
    const id = workIdElement?.dataset.largeWorkId;
    if (!id) return;

    const response = await fetch(`/works/${id}`, {
      headers: { Accept: "application/json" }
    });
    console.log(response);
    const largeWork = await response.json();
    console.log(largeWork);

    this.popupTarget.innerHTML = this.buildPopupHtml(
      largeWork,
      eventLine.getAttribute("event_id")
    );

    const touch = event.changedTouches?.[0];
    const clientX = touch ? touch.clientX : event.clientX;
    const clientY = touch ? touch.clientY : event.clientY;

    this.popupTarget.style.top = `${clientY - 20}px`;
    this.popupTarget.style.left = `${clientX + 30}px`;
    this.popupTarget.style.display = "block";
  }

  buildPopupHtml(largeWork, eventId) {
    const factoryType = this.popupTarget.getAttribute("name");
    return factoryType === "die"
      ? this.dieFactoryHtml(largeWork, eventId)
      : this.platingFactoryHtml(largeWork, eventId);
  }

  dieFactoryHtml(largeWork, eventId) {
    const approveButtonText =
      largeWork.status === "計画未承認" ? "承認" : "承認済み";
    const approveButtonColor =
      largeWork.status === "計画未承認" ? "btn-primary" : "btn-secondary";
    const chargeFullColor = largeWork.charge_full_flag
      ? "btn-secondary"
      : "btn-primary";
    const confirmedByGenbaColor = largeWork.order?.confirmed_by_genba
      ? "btn-secondary"
      : "btn-primary";
    const finishButtonColor =
      largeWork.status === "完了" ? "btn-secondary" : "btn-primary";
    const energizeRecordButtonColor = largeWork.energize_record_id
      ? "btn-secondary"
      : "btn-primary";
    const inspectionReportButtonColor = largeWork.inspection_report
      ? "btn-secondary"
      : "btn-primary";

    const attachments = largeWork.image_filenames_and_ids
      .map(
        ({ filename, id }) => `
        <div class="me-2"><a href="/orders/${id}/display">${filename}</a></div>
      `
      )
      .join("");

    const photo = largeWork.file_url
      ? `<div class="text-center">
          <a href="${largeWork.file_url}">
            <img src="${largeWork.image_url}" class="w-75" />
          </a>
        </div>`
      : "";

    return `
      <div class="row text-sm" data-work-id="${
        largeWork.id
      }" data-event-id="${eventId}">
        <div class="col-9">
          <div>受付番号: <a href="/orders/${largeWork.order_id}/edit">${
      largeWork.order.code
    }</a></div>
          <div>状況: ${largeWork.status}</div>
          <div>得意先名: ${largeWork.client_name_cache}</div>
          <div>引取先名: ${
            largeWork.in_delivery_destination_company_name_cache
          }</div>
          <div>納品先名: ${
            largeWork.out_delivery_destination_company_name_cache
          }</div>
          <div>営業担当: ${largeWork.order.representative}</div>
          <div>車種: ${largeWork.order.car_type}</div>
          <div>品番: ${largeWork.order.product_code}</div>
          <div>品名: ${largeWork.order.product_name}</div>
          <div>型工程: ${largeWork.order.mold_type}</div>
          <div>型構成: ${largeWork.order.mold_name}</div>
          <div>寸法: ${largeWork.order.length} × ${largeWork.order.width} × ${
      largeWork.order.height
    }</div>
          <div>面積: ${largeWork.order.area}</div>
          <div>重量: ${largeWork.order.weight}</div>
          <div>処理: ${largeWork.procedure.name}</div>
          <div>引取日時: ${largeWork.in_delivery_loading_at_cache}</div>
          <div>到着日時: ${largeWork.in_delivery_unloading_at_cache}</div>
          <div>積込日時: ${largeWork.out_delivery_loading_at_cache}</div>
          <div>納品日時: ${largeWork.out_delivery_unloading_at_cache}</div>
          <div>引取輸送: ${
            largeWork.in_delivery_representative_name_cache || ""
          }</div>
          <div>納品輸送: ${
            largeWork.out_delivery_representative_name_cache || ""
          }</div>
          <div>生産部署: ${largeWork.main_supplier_name}</div>
          <div>備考: ${largeWork.order.memo}</div>
          <div>
            <div>[資料]</div>
            ${attachments}
          </div>
          <div>[写真]</div>
          ${photo}
          <div>ID: ${largeWork.id}</div>
        </div>
        <div class="col-3 text-center">
          <button type="button" class="btn ${approveButtonColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#updateWorkStatusApproved">${approveButtonText}</button>
          <button type="button" class="btn ${chargeFullColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#updateWorkChargeFull">予定一杯</button>
          <button type="button" class="btn ${confirmedByGenbaColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#updateWorkConfirmedByGenba">現場確認</button>
          <button type="button" class="btn ${finishButtonColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#updateWorkStatusFinished">完了</button>
          <button type="button" class="btn ${energizeRecordButtonColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#createEnergizeRecord" data-energize-record-id="${
      largeWork.energize_record_id
    }">通電記録</button>
          <button type="button" class="btn ${inspectionReportButtonColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#createInspectionReport" data-inspection-report-id="${
      largeWork.inspection_report?.id
    }">検査表</button>
        </div>
      </div>
    `;
  }

  platingFactoryHtml(largeWork, eventId) {
    console.log(largeWork);
    const approveButtonText =
      largeWork.status === "計画未承認" ? "承認" : "承認済み";
    const approveButtonColor =
      largeWork.status === "計画未承認" ? "btn-primary" : "btn-secondary";
    const chargeFullColor = largeWork.charge_full_flag
      ? "btn-secondary"
      : "btn-primary";
    const platingFinishButtonColor = ["めっき完了", "検査完了"].includes(
      largeWork.status
    )
      ? "btn-secondary"
      : "btn-primary";
    const checkFinishButtonColor =
      largeWork.status === "検査完了" ? "btn-secondary" : "btn-primary";
    const energizeRecordButtonColor = largeWork.energize_record_id
      ? "btn-secondary"
      : "btn-primary";
    const inspectionReportButtonColor = largeWork.inspection_report_id
      ? "btn-secondary"
      : "btn-primary";

    const photo = largeWork.file_url
      ? `<div class="text-center">
          <a href="${largeWork.file_url}">
            <img src="${largeWork.image_url}" class="w-75" />
          </a>
        </div>`
      : "";

    return `
      <div class="row text-sm" data-work-id="${largeWork.id}" data-event-id="${eventId}">
        <div class="col-9">
          <div>受付番号: <a href="/orders/${largeWork.order_id}/edit">${largeWork.order.code}</a></div>
          <div>状況: ${largeWork.status}</div>
          <div>得意先名: ${largeWork.client_name_cache}</div>
          <div>営業担当: ${largeWork.order.representative}</div>
          <div>品名: ${largeWork.order.product_name}</div>
          <div>寸法: ${largeWork.order.length} × ${largeWork.order.width} × ${largeWork.order.height}</div>
          <div>受付者: </div>
          <div>めっき厚: ${largeWork.min_plating_thickness} - ${largeWork.max_plating_thickness}</div>
          <div>数量: ${largeWork.order.quantity}</div>
          <div>材質: ${largeWork.order.material}</div>
          <div>納期: ${largeWork.order.deadline_at}</div>
          <div>納品方法: ${largeWork.order.delivery_type}</div>
          <div>備考: ${largeWork.order.memo}</div>
          <div>写真:</div>
          ${photo}
          <div>ID: ${largeWork.id}</div>
        </div>
        <div class="col-3 text-center">
          <button type="button" class="btn ${approveButtonColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#updateWorkStatusApproved">${approveButtonText}</button>
          <button type="button" class="btn ${chargeFullColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#updateWorkChargeFull">予定一杯</button>
          <button type="button" class="btn ${platingFinishButtonColor} btn-sm mb-4" style="width: 110px;" data-action="click->dhtmlx-scheduler#updateWorkStatusFinished">めっき完了</button>
          <button type="button" class="btn ${checkFinishButtonColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#updateWorkStatusFinished">検査完了</button>
          <button type="button" class="btn ${energizeRecordButtonColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#createEnergizeRecord" data-energize-record-id="${largeWork.energize_record_id}">通電記録</button>
          <button type="button" class="btn ${inspectionReportButtonColor} btn-sm mb-4" data-action="click->dhtmlx-scheduler#createInspectionReport" data-inspection-report-id="${largeWork.inspection_report_id}">検査表</button>
        </div>
      </div>
    `;
  }
}
